// Module-level cache for admin-managed Departure Rules.
// Loaded once at login (or lazily) and read synchronously by
// `computeDepartureRule` in date.js — falls back to the hard-coded rules when
// this cache is empty.

import api from "@/lib/api";

let CACHED_RULES = [];
let LOAD_PROMISE = null;

/** Read the current cached rules (empty array if never loaded). */
export function getDepartureRules() {
  return CACHED_RULES;
}

/** Overwrite the cache — used by admin CRUD after mutations. */
export function setDepartureRules(rules) {
  CACHED_RULES = Array.isArray(rules) ? rules : [];
}

/** Fetch active rules and cache them. Idempotent; concurrent calls share the same promise. */
export function loadDepartureRules(force = false) {
  if (!force && LOAD_PROMISE) return LOAD_PROMISE;
  if (!force && CACHED_RULES.length > 0) return Promise.resolve(CACHED_RULES);
  LOAD_PROMISE = api
    .get("/departure-rules")
    .then((r) => {
      CACHED_RULES = Array.isArray(r.data) ? r.data : [];
      return CACHED_RULES;
    })
    .catch(() => {
      CACHED_RULES = [];
      return CACHED_RULES;
    })
    .finally(() => {
      LOAD_PROMISE = null;
    });
  return LOAD_PROMISE;
}

/** Clear cache — used on logout. */
export function clearDepartureRules() {
  CACHED_RULES = [];
  LOAD_PROMISE = null;
}
